import React from "react";
import * as CHQ from "chq";

import { ProfileLink } from "app/links";
import { Trans } from "app/utils";

import NotificationBody from "./NotificationBody";

type EventDeletedNotificationProps = {
  notification: CHQ.NotificationEventDeleted;
  tabIndex?: number;
};

const EventDeletedNotification: React.FC<EventDeletedNotificationProps> = ({
  notification: { actor, message }, tabIndex
}) => {
  const [name, note] = message.split(" -- ");

  return (
    <NotificationBody actor={actor}>
      <ProfileLink user={actor} tabIndex={tabIndex || 0} />
      {" "}
      <Trans>deleted the event:</Trans>
      {" "}
      {name}
      <br />
      {note && `"${note}"`}
    </NotificationBody>
  );
};

export default EventDeletedNotification;
